import axios from "axios";

// API configuration file
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

// Authentication travels as httpOnly cookies, which the browser only attaches
// to cross-origin requests when the request explicitly asks for credentials.
// Setting it here means every axios call in the app inherits it.
axios.defaults.withCredentials = true;

export default API_URL;
